import { useList } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { Civico } from "../types"

export function useCiviciList(params: Record<string, string | string[] | number[] | number> = {}) {
  return useList<Civico>(`${API_URL}/civici`, { query: params })
}
